module.exports = __webpack_public_path__ + "assets/img/info-btn-e66db782.png";